/* ---------------------------------==-=-=-=-=-=-=------------------------------- */

import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Image,
  ListGroup,
  Modal,
  Navbar,
  Row,
} from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import Carousel from "react-bootstrap/Carousel";
import { useLocation, useParams } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { GrCart } from "react-icons/gr";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useContext } from "react";
import { CartContext } from "./CartContext";
import { apibasePath } from "../config";
const Mainjewel = () => {
  const { id } = useParams(); // Get the ID from the URL
  const [product, setProduct] = useState(null);
  const [logo, setLogo] = useState({});
  // const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [name, setName] = useState("");

  const { cartItems, setCartItems } = useContext(CartContext);
  //  const { cartCount } = useContext(CartContext);
  const [cartCount, setCartCount] = useState([]);
  //zoom pointer

  const [CartsCounts, setCartsCounts] = useState([]);

  const Token = localStorage.getItem("token");

  const [showModal, setShowModal] = useState(false);

  const [DeleteTag, setDeleteTag] = useState({ item_tag: "" });

  const handleImageClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  //////////////////////////////
  const fetchCartItems = async () => {
    const Token = localStorage.getItem("token");
    // if (!Token) return;
    // setRefreshing(true);
    try {
      const response = await axios.get(
        `${apibasePath}/client/customer-cart-details/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("sandeep cart", response.data);
      setCartCount(response.data);

      // // assuming response.data is an array of cart items
      // const items = response.data || [];
      // setCartItems(items.map((item) => item.item_tag));
      // setCartCount(items.length);
      // setRefreshing(false);
    } catch (error) {
      console.error("Failed to fetch cart items:", error);
    }
  };

  const count_Api = `${apibasePath}/client/cart-count/`;

  const cartCountfeatchData = async () => {
    try {
      const response = await axios.get(count_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("carttssssscount", response?.data?.cart_count);
      setCartsCounts(response?.data?.cart_count); // Assuming response.data is an array of size values
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  useEffect(() => {
    cartCountfeatchData();
  }, [id]);

  useEffect(() => {
    fetchdatas();
    fetchCartItems();
  }, []);

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;
  const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  const Api_url = `${apibasePath}/client/profiles/company/`;

  const fetchdatas = async () => {
    try {
      const response = await axios.get(Api_url, {
        headers: { "Content-Type": "application/json" },
      });
      setLogo(response.data.logo);
      setName(response.data.name);
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  const Api_Url = `${apibasePath}/client/item/`;

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const TOKEN = localStorage.getItem("token");
        const res = await axios.get(`${apibasePath}/client/item/${id}/`, {
          headers: {
            Authorization: `bearer ${TOKEN}`,
          },
        });
        setProduct(res.data); // Set the fetched product data
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, [id]); // Add product to dependency array

  const handleSidebarShow = () => setShowSidebar(true);

  if (!product) {
    return <div>No product data found.</div>; // Handle missing data
  }

  const API_URL = `${apibasePath}/client/cart/add/`;

  // const handleAddToCart = async (product) => {
  //     const Token = localStorage.getItem("token");

  //     try {
  //         setLoading(true);
  //         const payload = product;
  //         const response = await axios.post(API_URL, payload, {
  //             headers: {
  //                 Authorization: `bearer ${Token}`,
  //                 "Content-Type": "application/json",
  //             },
  //         });

  //         // Update cartItems immediately after successful API call
  //         setCartItems((prevCart) => [...prevCart, product.item_tag]);

  //         setLoading(false);
  //     } catch (error) {
  //         console.error("Error adding to cart", error);
  //         setLoading(false);
  //         //check if error is because of item already in cart.
  //         if (error.response && error.response.status === 400) { //example of conflict status code
  //             //if the api returns a 409 conflict, it means the item is already added.
  //             //if your api returns a different error code for already added items, change 409 to that code.
  //             alert("Item already in cart. Please update the quantity.");
  //             //update cartItems in case it was not updated previously.
  //             if (!cartItems.includes(product.item_tag)) {
  //                 setCartItems((prevCart) => [...prevCart, product.item_tag]);
  //             }

  //         } else {
  //             alert("An error occurred while adding to cart.");
  //         }

  //     }
  // };
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleAddToCart = async (product) => {
    const Token = localStorage.getItem("token");
    try {
      const response = await axios.post(API_URL, product, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      const newCart = [...cartItems, product.item_tag];
      setCartItems(newCart);
      console.log("button cart list", cartItems);
      fetchCartItems();
      cartCountfeatchData();
      setLoading(false);
    } catch (error) {
      console.error("Error adding to cart", error);
      if (error.response?.status === 400) {
        if (!cartItems.includes(product.item_tag)) {
          setCartItems([...cartItems, product.item_tag]);
        }
      } else {
        alert("An error occurred while adding to cart.");
      }
    }
  };

  const Api_Delete = `${apibasePath}/client/delete-by-tag/`;

  const handleDelete = async (product) => {
    console.log("product no", product);
    const Token = localStorage.getItem("token");

    try {
      const response = await axios.delete(Api_Delete, {
        data: { item_tag: product.item_tag },
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      setDeleteTag(response.data);
      console.log("Product deleted successfully:", product);
      console.log("delete response", response);
      fetchCartItems();
      cartCountfeatchData();

      setLoading(false);
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleCartAction = async (product) => {
    console.log("cartitrfgd", cartItems);

    try {
      const isInCart = cartItems.includes(product.item_tag);

      if (isInCart) {
        await handleDelete(product);
        setCartItems((prevItems) =>
          prevItems.filter((item) => item !== product.item_tag)
        );
      } else {
        await handleAddToCart(product);

        setCartItems((prevItems) => [...prevItems, product.item_tag]);
      }
    } catch (error) {
      console.error("Cart action failed:", error);
    }
  };
  const handleCartActionDelete = async (product) => {
    try {
      const isInCart = cartItems.includes(product.item_tag);

      if (isInCart) {
        await handleDelete(product);
        setCartItems((prevItems) =>
          prevItems.filter((item) => item !== product.item_tag),
        );
      }
    } catch (error) {
      console.error("Cart action failed:", error);
    }
  };
  return (
    <div>
      {/* Render product details */}
      <Navbar className="bg-body-tertiary" expand="md">
        <Container fluid>
          <Navbar.Brand>
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={logo}
                alt="companylogo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                onContextMenu={handleContextMenu}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>

          <Navbar.Brand className="">
            <a href="/add-to-cartdetails" style={{ position: "relative" }}>
              <GrCart
                style={{ width: "30px", height: "30px", color: "#396D72" }}
              />

              {CartsCounts > 0 && ( // Only show the count if it's greater than 0
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "50%",
                    padding: "4px 7px",
                    fontSize: "12px",
                  }}
                >
                  <h1 style={{ fontSize: "12px", margin: 0 }}>{CartsCounts}</h1>
                </span>
              )}
            </a>
          </Navbar.Brand>
        </Container>
      </Navbar>

      <Container className="my-5">
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center">
            <img
              className="img-fluid w-100"
              style={{
                maxHeight: "600px",
                objectFit: "contain",
                backgroundSize: "cover",
                borderRadius: "10px",
                width: "100%",
                height: "100%",
                cursor: "pointer",
              }}
              src={
                product.image ||
                "https://assets0.mirraw.com/images/7007757/image_zoom.jpeg?1557322214"
              }
              alt="Product Image"
              onClick={handleImageClick}
              onContextMenu={handleContextMenu}
            />

            <Modal
              show={showModal}
              onHide={handleCloseModal}
              centered
              dialogClassName="modal-halfscreen" // or "large-modal" if you change it
              backdrop="static"
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundColor: "#c6c2c1", // set your desired color here
                  borderBottom: "none",
                }}
              ></Modal.Header>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  borderTop: "none",
                  height: "100vh",
                  backgroundColor: "#c6c2c1",
                }}
              >
                <div
                  style={{
                    maxHeight: "100vh",
                    overflowY: "auto",
                    border: "none",
                  }}
                >
                  <img
                    src={
                      product.image ||
                      "https://assets0.mirraw.com/images/7007757/image_zoom.jpeg?1557322214"
                    }
                    onContextMenu={handleContextMenu}
                    alt="Product"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxWidth: "100%",
                      objectFit: "contain",
                      border: "none",
                    }}
                  />
                </div>
              </div>
            </Modal>
          </Col>

          {/* Product Details Column */}
          <Col xs={12} md={6} className="text-center text-md-start mt-4">
            <h3
              style={{
                fontFamily: "Roboto",
                fontWeight: "600",
                fontSize: "18px",
                lineHeight: "0.5",
              }}
            >
              {product.item_tag || "Product Name"}
            </h3>
            <h3
              style={{
                fontFamily: "Roboto",
                fontWeight: "600",
                fontSize: "18px",
                paddingBottom: "10px",
                lineHeight: "1",
                letterSpacing: "0",
              }}
            >
              {product.item_name}
            </h3>
            <p
              style={{
                fontFamily: "Roboto",
                fontWeight: "400",
                lineHeight: "0.5",
              }}
            >
              Gross Wt&nbsp; :{" "}
              {product.gross_weight % 1 === 0
                ? product.gross_weight
                : Number(product.gross_weight).toFixed(3) || "N/A"}{" "}
              gm
            </p>
            <p
              style={{
                fontFamily: "Roboto",
                fontWeight: "400",
                lineHeight: "0.5",
              }}
            >
              Net Wt&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
              {product.net_weight % 1 === 0
                ? product.net_weight
                : Number(product.net_weight).toFixed(3) || "N/A"}{" "}
              gm
            </p>
            <p
              style={{
                fontFamily: "Roboto",
                fontWeight: "400",
                lineHeight: "0.5",
              }}
            >
              Stone Wt&nbsp; :{" "}
              {product.stone_weight % 1 === 0
                ? product.stone_weight
                : Number(product.stone_weight).toFixed(3) || "N/A"}{" "}
              gm
            </p>
            <p
              style={{
                fontFamily: "Roboto",
                fontWeight: "400",
                lineHeight: "0.5",
              }}
            >
              <>
                Size&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                {product.size || "N/A"}
              </>
            </p>

            <Button
              variant="primary"
              className="w-100"
              style={{
                backgroundColor: cartItems.includes(product.item_tag)
                  ? "#396D72"
                  : "#D1B457",
                border: "none",
                borderRadius: "0 0 15px 15px",
              }}
              onClick={() => handleCartAction(product)}
            >
              {cartItems.includes(product.item_tag) ? (
                <>
                  Added to Cart
                  <Button
                    className="Add_cart"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      paddingLeft: "10px",
                      paddingTop: "0px",
                      paddingBottom: "0px",
                      // marginLeft:'10%'
                      alignItems: "center",
                    }}
                    onClick={() => handleCartActionDelete(product)}
                  >
                    <MdDelete />
                  </Button>
                </>
              ) : (
                "Add to Cart"
              )}
            </Button>
          </Col>
        </Row>
      </Container>

      {/* <div align='center' style={{ fontFamily: 'Roboto', marginTop: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>POWERED BY</h4>
                    <div style={{ width: "100px", height: '50px', borderRadius: '10px', overflow: 'hidden', alignItems: 'center', justifyContent: 'center' }} ><img src={brandLogo} alt="Brandlogo" style={{ width: '100%', height: '100%', backgroundSize: 'cover' }} /></div>                </div>
            </div> */}
      <div align="center" style={{ fontFamily: "Roboto", marginTop: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <h4
            align="center"
            style={{ fontSize: "14px", marginTop: "31px", color: "#35646E" }}
          >
            POWERED BY
          </h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "5px", //add some space between text and logo
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mainjewel;
